import { createContext, useContext, useMemo, type ReactNode } from 'react'
import { VVDN_BRAND } from '../config/brand'

type ScopeValue = {
  orgId: string
  token: string | null
  locationFilter: string
  scopeLabel: string
}

const FloorPlanScopeContext = createContext<ScopeValue | null>(null)

export function FloorPlanScopeProvider({ children }: { children: ReactNode }) {
  const value = useMemo<ScopeValue>(
    () => ({
      orgId: VVDN_BRAND.orgId,
      token: null,
      locationFilter: VVDN_BRAND.siteId,
      scopeLabel: VVDN_BRAND.siteName,
    }),
    [],
  )
  return <FloorPlanScopeContext.Provider value={value}>{children}</FloorPlanScopeContext.Provider>
}

function useScope() {
  const ctx = useContext(FloorPlanScopeContext)
  if (!ctx) throw new Error('FloorPlanScopeProvider required')
  return ctx
}

/** Drop-in for NMS AuthContext in copied FloorPlanMap. */
export function useAuth() {
  const { orgId, token } = useScope()
  return { orgId, token }
}

/** Drop-in for NMS TenantScopeContext in copied FloorPlanMap. */
export function useTenantScope() {
  const { locationFilter, scopeLabel } = useScope()
  return { locationFilter, scopeLabel }
}
